import Marionette from 'backbone.marionette';
import { OrganizationDetailView, Props } from 'components/organizationDetailView'
import { IEsApiEntity as Entity } from 'models/esResult'
import * as _ from 'underscore'
import * as React from "react";
import ReactWrapper from 'views/marionetteReactWrapper';
import LayoutView from 'views/layoutView'
import { IKbApiEntity } from 'models/kbApiEntity'

class OrganizationsDetailController extends Marionette.Controller {
  initialize(opts: { organization?: IKbApiEntity }) {
    if (opts.organization) {
      this.organization = opts.organization
    }
    this.view = new LayoutView()
    this.listenTo(this.view, 'render', () => this.renderView())
  }

  renderView(additionalOpts?: object) {
    const props = this.buildProps(additionalOpts)
    const sidebarView = new ReactWrapper({
      getComponent: () => (<OrganizationDetailView {...props} />)
    });
    this.view.showView(sidebarView);
  }

  buildProps(additionalProps?: object): object {
    let props: Props = {}
    if (this.organization && this.organization.data) {
      props['organization'] = this.organization
    }
    return _.extend(props, additionalProps)
  }
}

export default OrganizationsDetailController;